<app-colored-background [backgroundColor]="'#389CC0'">
  <div style="width: 100dvw; min-height: 86px;"></div>
  <div>
    <div class="base-content-container" style="gap:8px;">
      <div>
        <div class="headline1" style="color: #FFFFFF">
          {{ locale.currentTranslation.tokenExpired1 }}
        </div>
        <div class="text-body1" style="color: #FFFFFF; margin-top: 8px;">
          <div>
            {{ locale.currentTranslation.tokenExpired2 }}
          </div>
        </div>
        <div class="text-body1" style="color: #FFFFFF; margin-top: 8px;">
          <div>
            {{ locale.currentTranslation.tokenExpired3 }}
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: center; margin-top: auto;">
        <img src="assets/img/door.png" class="fullscreen-page-highlight-image">
      </div>

    </div>
    <app-finish-box></app-finish-box>
    <div class="main-button-spacing">
      <a href="https://third-wave.tripleai-dev.com/api/session/new">
        <div class="main-button">{{ locale.currentTranslation.tokenExpiredNext }}
        </div>
      </a>
    </div>
  </div>

  <app-footer></app-footer>
</app-colored-background>
